module.exports = __webpack_public_path__ + "img/002.e2a458ab.png";